export const GET_CITIES = "GET_CITIES";
export const SITE_DETAILS = 'site_details'
export const CREATE_TASK = 'create_task'
export const TASK_LIST = 'task_list'
export const SITE_VISIT_TASK = 'site_visit_task'
export const SITE_VISIT_LIST = 'site_visit_list'
export const SITE_VISIT_BY_ID = 'site_visit_by_id'
export const SUB_HARDWARE_DROPDOWN = 'SUB_HARDWARE_DROPDOWN'
export const RM_CHECK_OUT = 'rm_check_out'
